import { httpMethods } from 'enums';
import { Http } from 'library';
import api from 'api/client';

import * as Endpoints from 'constants/endpoints.constant';

class ReferralUndertaking {
  async referralCodeUndertaking(payload) {
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(`${Endpoints.REFERRAL_CODE_UNDERTAKING}`)
      // .setUrl(`${Endpoints.GET_SCHEDULE_LIST}?${query}`)
      .setData(payload)
      .setToken(api.getToken())
      .request();
  }

  async isReferralCodeValid(investorId: any) {
    return await Http.setMethod(httpMethods.get)
      .setUrl(`${Endpoints.IS_REFERRAL_CODE_VALID}/${investorId}`)
      // .setUrl(`${Endpoints.GET_SCHEDULE_LIST}?${query}`)
      .setToken(api.getToken())
      .request();
  }
}

export default new ReferralUndertaking();
